// Per-client options of the Visits Viewer, read from `bi_config` (module `visits_viewer`).
// Backend twin: backend/config/biConfigRegistry.js (VISITS_FEATURES).

export const VISITS_FEATURES = { TARGETS: 'targets', DURATIONS: 'durations' };

// No row for the client: every analysis is open, as before the config existed.
export const DEFAULT_VISITS_CONFIG = { admin_only: [] };

/**
 * Who sees a feature, and whether admins see it flagged with the shield.
 * Fails closed for non-admins while the config loads; a malformed config
 * (null, {}, `admin_only` not an array) reads as open.
 */
export const getFeatureAccess = (config, loaded, feature, isAdmin) => {
  if (!loaded) return { visible: Boolean(isAdmin), adminOnly: false };
  const adminOnlyFlags = Array.isArray(config?.admin_only) ? config.admin_only : [];
  if (!adminOnlyFlags.includes(feature)) return { visible: true, adminOnly: false };
  return isAdmin ? { visible: true, adminOnly: true } : { visible: false, adminOnly: false };
};

// Access of a feature no config restricts: the default for direct component renders.
export const OPEN_FEATURE_ACCESS = { visible: true, adminOnly: false };
